export const COOLER_TRANSACTION_TEST_IDS = {
  PAGE: 'cooler-transaction-page',
  SEARCH_INPUT: 'cooler-transaction-search-input',
  FILTER_DROPDOWN: 'cooler-transaction-filter-dropdown',
  TYPE_FILTER: 'cooler-transaction-type-filter',
  STATUS_FILTER: 'cooler-transaction-status-filter',
  STATUS_CODE_FILTER: 'cooler-transaction-status-code-filter',
  TABLE: 'cooler-transaction-table',
  TABLE_ROW: (id: string) => `cooler-transaction-table-row-${id}`,
  COL_TRANSACTION_ID: (id: string) =>
    `cooler-transaction-col-transaction-id-${id}`,
  COL_OPERATOR_PROVIDER: (id: string) =>
    `cooler-transaction-col-operator-provider-${id}`,
  COL_MARKET: (id: string) => `cooler-transaction-col-market-id-${id}`,
  COL_DEVICE_ID: (id: string) => `cooler-transaction-col-device-id-${id}`,
  COL_TYPE: (id: string) => `cooler-transaction-col-type-${id}`,
  COL_STATUS: (id: string) => `cooler-transaction-col-status-${id}`,
  COL_STATUS_CODE: (id: string) => `cooler-transaction-col-status-code-${id}`,
  COL_CREATED_ON: (id: string) => `cooler-transaction-col-created-on-${id}`,
  COL_UPDATED_ON: (id: string) => `cooler-transaction-col-updated-on-${id}`,

  // ── Expanded row panel ───────────────────────────────────────────────
  EXPANDED_PANEL: 'cooler-transaction-expanded-panel',
  EXPANDED_STEPPER: 'cooler-transaction-expanded-stepper',
  EXPANDED_ACTIVITY: 'cooler-transaction-expanded-activity',
  EXPANDED_ERRORS: 'cooler-transaction-expanded-errors',
} as const;
